import { Component, OnDestroy, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { AppState } from 'app/store/model';
import { CameraActions } from 'app/cameras/Services/actions';
import { environment } from 'environments/environment';
import { Camera, Plan } from '../models';
import { Store } from '@ngrx/store';
import { UserInventory } from 'app/Users/models';
import { UserService } from 'app/Users/Services/user.service';
import { ValidationResponseHandlerModule } from 'app/Shared/ValidationResponse/validation-response-handler';

@Component({
    selector: 'app-camera-plans',
    templateUrl: './camera-plans.component.html',
    styleUrls: ['./camera-plans.component.scss'],
    standalone: false
})
export class CameraPlansComponent implements OnInit, OnDestroy, OnChanges {
    readonly plans$ = this.store.select((state: AppState) => state.camera.plans);

    @Input() plan_id: number;
    getPlans: Subscription;
    userInventory: Subscription;

    outId: Subject<number> = new Subject<number>();
    associate_id = environment.associateId;
    plansList: Plan[] = [];
    save_changes;
    activePlan: number;
    isAssociate: boolean;
    adminAssociate: boolean;
    isPartner: boolean;
    availableInventory = [];
    inventory: UserInventory;
    loadingPlans: boolean;
    userSub: string;
    isMaster = localStorage.getItem('profile_name') === '7d4e9f24-17e8-11ec-9621-0242ac130002';
    isMasterAssociate = localStorage.getItem('profile_name') === '7415bb4a-c1e9-401d-870a-7af65a8e3acd';
    partnerSub = localStorage.getItem('partnerSub');
    smartSampa: boolean;

    private resetSelectionToInitial(): void {
        this.activePlan = this.plan_id;     // volta visualmente para o plano original
        this.planId.emit(this.plan_id);      // re-sincroniza com o componente pai
        this.save_changes = false;           // desabilita "Salvar Alterações"
    }


    @Input() loading: boolean;
    @Input() smartSampaData: string;
    @Output() planId = new EventEmitter<number>();
    @Output() camEditData = new EventEmitter<boolean>();
    @Output() cancelEmmiter = new EventEmitter<void>();
    @Output() saveEmmiter = new EventEmitter<Object>();

    constructor(private readonly store: Store<AppState>, private service: UserService, private validationResponse: ValidationResponseHandlerModule) { }

    ngOnInit(): void {
        this.userSub = localStorage.getItem('sub');
        this.loadingPlans = true;
        this.plans();
        this.getInventory();
        this.smartSampa = true;

        if (localStorage.getItem('profile_name') == 'cd343bfc-17e8-11ec-9621-0242ac130002') {
            this.isPartner = true;
        }
        if (localStorage.getItem('profile_name') === 'f29868c7-b4c5-4963-9ae8-1dd95699d6c3') {
            this.isAssociate = true;
        }
        if (this.isAssociate && localStorage.getItem('associate_permission') === 'e816c560-812e-11ed-a1eb-0242ac120002') {
            this.adminAssociate = true;
        }

    }

    ngOnDestroy() {
        if (this.getPlans) {
            this.getPlans.unsubscribe();
        }
        if (this.userInventory) {
            this.userInventory.unsubscribe();
        }
        this.store.dispatch(CameraActions.get_plans_cleanup());
    }

    ngOnChanges(): void {
        if (this.activePlan === undefined) {
            this.activePlan = this.plan_id;
        }
    }

    // Retorna as informações da lista de planos
    plans() {
        this.getPlans = this.plans$.subscribe(result => {
            if (result) {
                this.plansList = result;
            }
            else {
                this.store.dispatch(CameraActions.get_plans({ associateId: this.associate_id }));
            }
        });
    }

    getInventory() {
        const clientSub = localStorage.getItem('clientView') ? localStorage.getItem('clientView') : null;
        this.service.userInventory(this.userSub, clientSub, this.partnerSub).subscribe(result => {
            if (result) {
                this.inventory = result[0];
                this.loadingPlans = false;

                const camerasInfoPartner = this.inventory.inventory.ci;
                const planLength = this.inventory.plans.length;

                for (let i = 0; i < planLength; i++) {
                    const plan = this.inventory.plans[i];
                    const idPlan = plan.id_plan;
                    camerasInfoPartner[idPlan].id = camerasInfoPartner[idPlan].id_plan;
                    this.availableInventory.push(camerasInfoPartner[idPlan]);
                    // if (camerasInfoPartner[idPlan].available >= 0) {
                    //     camerasInfoPartner[idPlan].id = camerasInfoPartner[idPlan].id_plan;
                    // this.availableInventory.push(camerasInfoPartner[idPlan]);
                    // }
                }
            }
        });
    }

    changePlan(id_plan) {
        if (this.adminAssociate || this.isPartner || this.isMaster || this.isMasterAssociate) {
            this.activePlan = id_plan;
            this.planId.emit(id_plan);
            this.save_changes = true;
        }
    }

    closeModal() {
        this.cancelEmmiter.emit();
    }

    saveChanges() {
        if (this.planId) {
            const plan = this.availableInventory.find(item => item.id_plan === this.activePlan);
            if (this.smartSampaData) {
                if (plan && (plan.days_storage < 7 || plan.resolution.alias != 'FULL HD')) {
                    this.validationResponse.validationResponseHandler(400, 'camera-plans', 'smart-sampa-fail');
                    this.resetSelectionToInitial();
                } else {
                    this.camEditData.emit(true);
                }
            } else {
                this.camEditData.emit(true);
            }
        }
    }

    processPlural(palavra: string, amount: number) {
        return palavra + (amount > 1 ? 's' : '');
    }
}
